/* Find a Baker - directory interactions (vanilla, no deps).
   Multi-select specialty chips (OR; "All" clears), city text search, fuzzy ZIP
   geocode (window.MM_ZIP3 3-digit prefix centroids) as a removable pill +
   distance filter (any/5/25/50/100 mi, defaults to 50 on a location search),
   geolocation distance+sort, card<->pin two-way selection, detail modal,
   and pin projection onto the stylized reference map. Swap the map render for a
   real provider later; the card/filter logic is provider-agnostic. */
function initFindABaker() {
  var root = document.querySelector('.fb');
  if (!root || !window.MM_BAKERS) return;
  var BAKERS = window.MM_BAKERS;
  var bySlug = {};
  BAKERS.forEach(function (b) { bySlug[b.slug] = b; });

  var listEl = root.querySelector('[data-fb-list]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fb-card]'));
  var countEl = root.querySelector('[data-fb-count]');
  var nearEl = root.querySelector('[data-fb-near]');
  var emptyEl = root.querySelector('[data-fb-empty]');
  var mapEl = root.querySelector('[data-fb-map]');
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-fb-chip]'));
  var searchInput = root.querySelector('[data-fb-search]');
  var modal = root.querySelector('[data-fb-modal]');
  var zipPill = root.querySelector('[data-fb-zip-pill]');

  /* ---- Leaflet map (self-hosted lib + Carto light basemap) ----
     CARTO began watermarking unauthenticated raster tiles with "API KEY REQUIRED" in late
     Aug 2026; the tiles still returned HTTP 200, so nothing alerted - it was only visible
     by looking at the rendered page. Free tier is 5M tile requests/month and requires the
     attribution below to stay visible. This key is PUBLIC by design (it ships in client-side
     JS and appears in every tile request) - it is not a secret, but per CARTO's terms do not
     reuse it for unrelated projects. Raster tiles may stop receiving data updates; the
     eventual migration is the vector style positron-gl-style via MapLibre. */
  var CARTO_KEY = 'cb1_3jp2_1_f2d380ac0b2f4a1d55b79bf1';
  var map = null, markerLayer = null, markers = {}, mapReady = false;
  function initMap() {
    if (mapReady || !mapEl || !window.L) return;
    map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true, attributionControl: true });
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=' + CARTO_KEY, {
      subdomains: 'abcd', maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
    }).addTo(map);
    markerLayer = L.layerGroup().addTo(map);
    map.setView([39.5, -98.35], 4); // continental US
    // show "Search this area" after a user pan/zoom (not our own fitBounds moves).
    // Our programmatic moves set progUntil to a short future time; anything after that
    // window is a user gesture. (A boolean flag can get stuck when a no-op fitBounds
    // fires no moveend.) dragend is an unambiguous user-pan signal.
    map.on('moveend', function () { if (Date.now() < progUntil) return; if (areaBtn) areaBtn.hidden = false; });
    map.on('dragend', function () { if (areaBtn) areaBtn.hidden = false; });
    mapReady = true;
    renderPins();
    // container height can read as 0 until layout/CSS settle; re-measure + re-fit
    requestAnimationFrame(function () { map.invalidateSize(); renderPins(); });
    window.addEventListener('load', function () { map.invalidateSize(); renderPins(); });
  }
  function pinSvg(sel) {
    var s = sel ? 46 : 32, fill = sel ? 'var(--mm-ink)' : '#6f645c';
    return '<svg width="' + s + '" height="' + (s * 42 / 32).toFixed(0) + '" viewBox="0 0 32 42" fill="none"><path d="M16 41C16 41 30 26 30 15A14 14 0 1 0 2 15C2 26 16 41 16 41Z" fill="' + fill + '" stroke="#fff" stroke-width="2"/><path d="M9 18 L14 10 L17 15 L20 8 L24 18 Z" fill="#fff"/></svg>';
  }
  function pinIcon(sel) {
    var s = sel ? 46 : 32, h = Math.round(s * 42 / 32);
    return L.divIcon({ className: 'fb-leaf-pin', html: pinSvg(sel), iconSize: [s, h], iconAnchor: [s / 2, h] });
  }

  var LIMIT = 30; // list shows this many at a time (map still shows all matches)
  var state = { chips: [], query: '', origin: null, originLabel: '', radius: 'any', userSetRadius: false, matched: [], limit: LIMIT, selected: (cards[0] && cards[0].getAttribute('data-fb-card')) || null, areaBounds: null };
  var areaBtn = root.querySelector('[data-fb-search-area]'); // "Search this area" overlay
  var _areaSearch = false;  // true only while applying a Search-this-area (so it isn't cleared)
  var progUntil = 0;        // timestamp until which map moves are ours (fitBounds), not a user pan
  var originalOrder = cards.slice(); // server order (alphabetical) to restore when clearing a location
  var loadMoreBtn = root.querySelector('[data-fb-loadmore]');

  // normalize text for search so common place-name abbreviations match either way
  // ("st paul"/"st. paul" <-> "saint paul", "mt"/"mount", "ft"/"fort")
  function normText(s) {
    return String(s || '').toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')      // punctuation -> space ("st." -> "st ")
      .replace(/\bsaint\b/g, 'st')
      .replace(/\bmount\b/g, 'mt')
      .replace(/\bfort\b/g, 'ft')
      .replace(/\s+/g, ' ').trim();
  }

  function haversine(a, b, c, d) {
    var R = 3958.8, dLat = (c - a) * Math.PI / 180, dLng = (d - b) * Math.PI / 180;
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a * Math.PI / 180) * Math.cos(c * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
  }

  // paint the list up to state.limit; the map (renderPins) uses ALL matches
  function renderList() {
    cards.forEach(function (c) { c.style.display = 'none'; });
    state.matched.forEach(function (c, i) { if (i < state.limit) c.style.display = ''; });
    if (loadMoreBtn) {
      var rem = state.matched.length - state.limit;
      if (rem > 0) { loadMoreBtn.hidden = false; loadMoreBtn.textContent = 'Load more (' + rem + ' more)'; }
      else { loadMoreBtn.hidden = true; }
    }
  }

  function applyFilters() {
    if (!_areaSearch) state.areaBounds = null; // any normal filter change clears the map-area lock
    state.limit = LIMIT; // any filter change resets to the first page
    var q = normText(state.query);
    var radiusMi = state.radius === 'any' ? Infinity : parseFloat(state.radius);
    var matched = [];
    cards.forEach(function (card) {
      var tags = (card.getAttribute('data-tags') || '').split('|');
      // OR logic: no chips selected = show all; else match ANY selected specialty
      var matchChip = state.chips.length === 0 || state.chips.some(function (t) { return tags.indexOf(t) !== -1; });
      var matchQuery = !q || normText(card.getAttribute('data-search') || '').indexOf(q) !== -1;
      var matchRadius = true;
      if (state.origin && radiusMi !== Infinity) {
        var d = parseFloat(card.getAttribute('data-distance'));
        matchRadius = !isNaN(d) && d <= radiusMi;
      }
      // "Search this area": only bakers whose pin is inside the current map viewport
      var matchArea = true;
      if (state.areaBounds) {
        var ba = bySlug[card.getAttribute('data-fb-card')];
        matchArea = !!(ba && ba.lat && ba.lng && state.areaBounds.contains([ba.lat, ba.lng]));
      }
      if (matchChip && matchQuery && matchRadius && matchArea) matched.push(card);
    });
    state.matched = matched;
    var total = matched.length;
    renderList();
    if (countEl) countEl.textContent = total;
    if (emptyEl) emptyEl.hidden = total !== 0;
    if (listEl) listEl.style.display = total === 0 ? 'none' : '';
    // location shows as a removable pill; nearEl only carries text-search / hint context
    if (nearEl) {
      var near = '';
      if (!state.origin && state.radius !== 'any') near = ' · pick a ZIP or use your location to filter by distance';
      else if (!state.origin && q) near = ' matching "' + state.query.trim() + '"';
      nearEl.textContent = near;
    }
    updatePill();
    // keep selection valid among matches
    if (total && (!state.selected || !matched.some(function (c) { return c.getAttribute('data-fb-card') === state.selected; }))) {
      state.selected = matched[0].getAttribute('data-fb-card');
    }
    renderSelection();
    renderPins();
  }
  if (loadMoreBtn) loadMoreBtn.addEventListener('click', function () { state.limit += LIMIT; renderList(); });

  // removable location pill ("Near ZIP 94103 · within 50 mi  x")
  function updatePill() {
    if (!zipPill) return;
    if (state.origin) {
      var txt = 'Near ' + state.originLabel + (state.radius !== 'any' ? ' · within ' + state.radius + ' mi' : '');
      zipPill.innerHTML = esc(txt) + ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      zipPill.hidden = false; zipPill.classList.add('is-shown');
    } else {
      zipPill.hidden = true; zipPill.classList.remove('is-shown'); zipPill.innerHTML = '';
    }
  }

  function renderSelection() {
    cards.forEach(function (c) { c.classList.toggle('is-selected', c.getAttribute('data-fb-card') === state.selected); });
    Object.keys(markers).forEach(function (slug) {
      markers[slug].setIcon(pinIcon(slug === state.selected));
      if (slug === state.selected && markers[slug]._icon) markers[slug]._icon.style.zIndex = 1000;
    });
  }

  function renderPins() {
    if (!mapReady || !markerLayer) return;
    map.invalidateSize(false); // ensure Leaflet knows the real container size before fitBounds
    markerLayer.clearLayers();
    markers = {};
    var vis = (state.matched || []).map(function (c) { return bySlug[c.getAttribute('data-fb-card')]; }).filter(function (b) { return b && b.lat && b.lng; });
    if (!vis.length) return;
    var pts = [];
    vis.forEach(function (b) {
      var m = L.marker([b.lat, b.lng], { icon: pinIcon(b.slug === state.selected), title: b.name, riseOnHover: true });
      m.on('click', function () { openModal(b.slug); });
      m.addTo(markerLayer);
      markers[b.slug] = m;
      pts.push([b.lat, b.lng]);
    });
    // don't re-fit while the user is browsing a chosen map area (keep their view)
    if (!state.areaBounds) {
      progUntil = Date.now() + 700;   // suppress the "Search this area" button for our own fit
      if (pts.length === 1) map.setView(pts[0], 11);
      else map.fitBounds(pts, { padding: [42, 42], maxZoom: 12 });
    }
    renderSelection();
  }
  function searchThisArea() {
    if (!mapReady) return;
    _areaSearch = true; state.areaBounds = map.getBounds(); applyFilters(); _areaSearch = false;
    if (areaBtn) areaBtn.hidden = true;
  }
  if (areaBtn) areaBtn.addEventListener('click', searchThisArea);

  function select(slug, scrollCard) {
    state.selected = slug;
    renderSelection();
    if (scrollCard) {
      var card = cards.filter(function (c) { return c.getAttribute('data-fb-card') === slug; })[0];
      if (card) card.scrollIntoView({ block: 'nearest' });
      if (mapReady && markers[slug]) map.panTo(markers[slug].getLatLng());
    }
  }

  function setOrigin(lat, lng, label) {
    state.origin = { lat: lat, lng: lng };
    state.originLabel = label || 'you';
    // default to a 50 mi radius on the first location search (unless the user picked one)
    if (!state.userSetRadius) { state.radius = '50'; if (distanceSel) distanceSel.value = '50'; }
    cards.forEach(function (card) {
      var la = parseFloat(card.getAttribute('data-lat')), ln = parseFloat(card.getAttribute('data-lng'));
      var span = card.querySelector('[data-fb-dist]');
      if (span && la && ln) {
        var mi = haversine(lat, lng, la, ln);
        span.textContent = (mi < 10 ? mi.toFixed(1) : Math.round(mi)) + ' mi';
        span.hidden = false;
        card.setAttribute('data-distance', mi);
      }
    });
    // sort visible cards by distance
    cards.sort(function (a, b) { return (parseFloat(a.getAttribute('data-distance')) || 1e9) - (parseFloat(b.getAttribute('data-distance')) || 1e9); });
    cards.forEach(function (c) { listEl.appendChild(c); });
    applyFilters();
  }

  // clear a location: hide distances, forget origin, restore server order
  function clearOrigin() {
    state.origin = null; state.originLabel = '';
    cards.forEach(function (c) { c.removeAttribute('data-distance'); var s = c.querySelector('[data-fb-dist]'); if (s) { s.hidden = true; s.textContent = ''; } });
    originalOrder.forEach(function (c) { listEl.appendChild(c); });
  }

  // ---- events ----
  // multi-select specialties (OR); "All" clears the selection; click again to unfilter
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var val = chip.getAttribute('data-fb-chip');
      if (val === 'All') { state.chips = []; }
      else {
        var i = state.chips.indexOf(val);
        if (i === -1) state.chips.push(val); else state.chips.splice(i, 1);
      }
      chips.forEach(function (c) {
        var v = c.getAttribute('data-fb-chip');
        c.classList.toggle('is-active', v === 'All' ? state.chips.length === 0 : state.chips.indexOf(v) !== -1);
      });
      applyFilters();
    });
  });

  // A ZIP is treated as a fuzzy location (3-5 digits -> prefix centroid); anything
  // with letters is a text search on name/city. ZIP need not be exact - we geocode
  // the 3-digit prefix and rank/filter by distance.
  function resetChips() {
    state.chips = [];
    chips.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-fb-chip') === 'All'); });
  }
  function doSearch() {
    var raw = searchInput ? searchInput.value.trim() : '';
    resetChips(); // a fresh search clears the specialty filter and refreshes results
    if (/^\d{3,5}(?:-\d{0,4})?$/.test(raw)) {
      var z3 = raw.slice(0, 3);
      var coord = window.MM_ZIP3 && window.MM_ZIP3[z3];
      if (coord) { state.query = ''; setOrigin(coord[0], coord[1], 'ZIP ' + raw); return; }
    }
    // text search: drop any prior location
    clearOrigin();
    state.query = raw;
    applyFilters();
  }
  var searchBtn = root.querySelector('[data-fb-searchbtn]');
  if (searchBtn) searchBtn.addEventListener('click', doSearch);
  if (searchInput) searchInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') doSearch(); });

  var distanceSel = root.querySelector('[data-fb-distance]');
  if (distanceSel) distanceSel.addEventListener('change', function () { state.radius = distanceSel.value; state.userSetRadius = true; applyFilters(); });

  // clicking the location pill removes the ZIP/location filter cleanly
  if (zipPill) zipPill.addEventListener('click', function () {
    clearOrigin();
    state.radius = 'any'; state.userSetRadius = false;
    if (distanceSel) distanceSel.value = 'any';
    if (searchInput) searchInput.value = '';
    applyFilters();
  });

  var geoBtn = root.querySelector('[data-fb-geo]');
  if (geoBtn) geoBtn.addEventListener('click', function () {
    if (!navigator.geolocation) return;
    geoBtn.textContent = 'Locating…';
    navigator.geolocation.getCurrentPosition(function (pos) {
      if (searchInput) searchInput.value = '';
      setOrigin(pos.coords.latitude, pos.coords.longitude, 'you');
      geoBtn.textContent = 'Using your location';
    }, function () { geoBtn.textContent = 'Location unavailable'; });
  });

  // two-way chip scrolling: buttons appear only when there's more to scroll that way
  var scrollLeftBtn = root.querySelector('[data-fb-scroll-left]');
  var scrollRightBtn = root.querySelector('[data-fb-scroll-right]');
  var chiprow = root.querySelector('[data-fb-chiprow]');
  function updateScrollBtns() {
    if (!chiprow) return;
    var max = chiprow.scrollWidth - chiprow.clientWidth;
    if (scrollLeftBtn) scrollLeftBtn.hidden = chiprow.scrollLeft <= 2;
    if (scrollRightBtn) scrollRightBtn.hidden = chiprow.scrollLeft >= max - 2;
  }
  if (scrollRightBtn && chiprow) scrollRightBtn.addEventListener('click', function () { chiprow.scrollBy({ left: 240 }); updateScrollBtns(); });
  if (scrollLeftBtn && chiprow) scrollLeftBtn.addEventListener('click', function () { chiprow.scrollBy({ left: -240 }); updateScrollBtns(); });
  if (chiprow) { chiprow.addEventListener('scroll', updateScrollBtns); window.addEventListener('resize', updateScrollBtns); updateScrollBtns(); }

  var directory = root.querySelector('[data-fb-directory]');
  Array.prototype.forEach.call(root.querySelectorAll('[data-fb-view]'), function (btn) {
    btn.addEventListener('click', function () {
      var v = btn.getAttribute('data-fb-view');
      if (directory) directory.setAttribute('data-view', v);
      Array.prototype.forEach.call(root.querySelectorAll('[data-fb-view]'), function (b) { b.classList.toggle('is-active', b === btn); });
      // map was display:none while in list view on mobile; Leaflet needs a resize + re-fit
      if (v === 'map' && mapReady) { setTimeout(function () { map.invalidateSize(); renderPins(); }, 60); }
    });
  });

  // card click -> open modal (href stays the real shareable URL for SEO/right-click)
  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let new-tab/open-in-new work
      e.preventDefault();
      openModal(card.getAttribute('data-fb-card'));
    });
    card.addEventListener('mouseenter', function () { select(card.getAttribute('data-fb-card'), false); });
  });

  // ---- modal ----
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function openModal(slug) {
    var b = bySlug[slug]; if (!b || !modal) return;
    state.selected = slug; renderSelection();
    var img = modal.querySelector('[data-fb-m-photo]');
    var fb = modal.querySelector('[data-fb-m-fallback]');
    var media = modal.querySelector('.fb-modal__media');
    if (b.photo) {
      img.src = b.photo; img.alt = b.name; img.style.display = ''; img.style.objectFit = 'cover'; img.style.padding = '0'; img.style.background = '';
      if (media) media.style.background = '';
      if (fb) fb.classList.remove('is-shown');
    } else if (b.logo) {
      img.src = b.logo; img.alt = b.name + ' logo'; img.style.display = ''; img.style.objectFit = 'contain'; img.style.padding = '30px'; img.style.background = '#fff';
      if (media) media.style.background = '#fff';
      if (fb) fb.classList.remove('is-shown');
    } else {
      img.src = ''; img.style.display = 'none';
      if (media) media.style.background = '';
      if (fb) {
        var initial = (b.name || 'B').trim().charAt(0).toUpperCase();
        fb.innerHTML = '<span>' + esc(initial) + '</span><svg width="34" height="34" viewBox="0 0 48 48" fill="none"><path d="M4 38 L18 16 L26 28 L32 18 L44 38 Z" fill="none" stroke="var(--mm-cocoa)" stroke-width="2" stroke-linejoin="round" opacity="0.4"/><circle cx="34" cy="14" r="3" fill="var(--mm-cocoa)" opacity="0.35"/></svg>';
        fb.classList.add('is-shown');
      }
    }
    modal.querySelector('[data-fb-m-name]').textContent = b.name;
    var loc = b.city + ', ' + b.state + (b.neighborhood ? ' · ' + b.neighborhood : '');
    if (b._dist != null) loc += ' · ' + b._dist;
    var card = cards.filter(function (c) { return c.getAttribute('data-fb-card') === slug; })[0];
    if (card && card.getAttribute('data-distance')) { var mi = parseFloat(card.getAttribute('data-distance')); loc += ' · ' + (mi < 10 ? mi.toFixed(1) : Math.round(mi)) + ' mi'; }
    modal.querySelector('[data-fb-m-loc]').textContent = loc;
    modal.querySelector('[data-fb-m-tags]').innerHTML = (b.tags || []).map(function (t) { return '<span class="fb-tag">' + esc(t) + '</span>'; }).join('');
    modal.querySelector('[data-fb-m-blurb]').textContent = b.blurb || '';
    var contact = '';
    if (b.website) contact += '<a href="' + esc(b.website) + '" target="_blank" rel="noopener"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20z"/></svg>' + esc(b.website.replace(/^https?:\/\//, '').replace(/\/$/, '')) + '</a>';
    if (b.instagram) { var ig = b.instagram.replace('@', ''); contact += '<a href="https://instagram.com/' + esc(ig) + '" target="_blank" rel="noopener"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1.2" fill="currentColor"/></svg>' + esc(b.instagram) + '</a>'; }
    if (b.phone) contact += '<a href="tel:' + esc(b.phone.replace(/[^0-9+]/g, '')) + '"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z"/></svg>' + esc(b.phone) + '</a>';
    modal.querySelector('[data-fb-m-contact]').innerHTML = contact;
    var dirEl = modal.querySelector('[data-fb-m-dir]');
    if (dirEl) {
      if (b.city) { dirEl.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(b.name + ', ' + b.city + ', ' + b.state); dirEl.style.display = ''; }
      else { dirEl.style.display = 'none'; }
    }
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() { if (modal) { modal.classList.remove('is-open'); document.body.style.overflow = ''; } }
  if (modal) {
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    var closeBtn = modal.querySelector('[data-fb-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  }

  applyFilters();
  initMap();
}

/* ---- full-directory bootstrap ------------------------------------------------------
   The section renders from `shop.metaobjects.baker.values`, which Liquid caps. On
   2026-10-14 that meant 50 cards and 50 pins for 131 live bakers: every listing published
   that week existed, was correct, and could not be reached from the map.

   So the server-rendered cards stay (crawlers and no-JS visitors get those), and this fetches
   the full set and fills in everything missing BEFORE the directory initialises - the filter,
   search, distance and map code all read the DOM and window.MM_BAKERS once at startup, so
   adding cards afterwards would leave the map and the list disagreeing.

   If the fetch fails the page still works, with the 50 it was always going to have. A map
   that is short is better than a map that is blank. */
(function () {
  var root = document.querySelector('.fb');
  if (!root) { return; }
  var url = root.getAttribute('data-fb-all');
  var listEl = root.querySelector('[data-fb-list]');
  if (!url || !listEl || !window.MM_BAKERS) { initFindABaker(); return; }

  /* City pages scope themselves in Liquid. Re-adding the national set there would silently
     turn a Seattle page into the whole country. */
  if (root.getAttribute('data-fb-scoped') === 'true') { initFindABaker(); return; }

  var esc = function (v) { return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };

  function media(b) {
    if (b.card && !b.cardIsLogo) return '<div class="fb-card__media"><img src="' + esc(b.card) + '" alt="' + esc(b.name) + '" width="132" height="150" loading="lazy"></div>';
    if (b.card) return '<div class="fb-card__media fb-card__media--logo"><img src="' + esc(b.card) + '" alt="' + esc(b.name) + ' logo" loading="lazy"></div>';
    /* Same fallback the snippet draws, so a card added here is indistinguishable from one
       Liquid rendered. */
    var initial = (b.name || 'B').trim().charAt(0).toUpperCase();
    return '<div class="fb-card__media"><span class="fb-card__fallback"><span style="display:flex;flex-direction:column;align-items:center;gap:5px;" aria-hidden="true">' +
      '<span style="font-family:var(--font-display);font-weight:700;font-size:32px;line-height:1;color:var(--mm-cocoa);opacity:.5;">' + esc(initial) + '</span>' +
      '<svg width="26" height="26" viewBox="0 0 48 48" fill="none"><path d="M4 38 L18 16 L26 28 L32 18 L44 38 Z" fill="none" stroke="var(--mm-cocoa)" stroke-width="2" stroke-linejoin="round" opacity="0.4"/><circle cx="34" cy="14" r="3" fill="var(--mm-cocoa)" opacity="0.35"/></svg>' +
      '</span></span></div>';
  }

  function cardHtml(b) {
    var loc = esc(b.city) + ', ' + esc(b.state) + (b.neighborhood ? ' \u00b7 ' + esc(b.neighborhood) : '');
    var search = (b.name + ' ' + b.city + ' ' + b.state + ' ' + (b.neighborhood || '')).toLowerCase();
    return '<a class="fb-card" href="' + esc(b.url) + '" data-fb-card="' + esc(b.slug) + '"' +
      ' data-tags="' + esc((b.tags || []).join('|')) + '" data-lat="' + esc(b.lat) + '" data-lng="' + esc(b.lng) + '"' +
      ' data-search="' + esc(search) + '">' + media(b) +
      '<div class="fb-card__body"><div class="fb-card__top"><h3 class="fb-card__name">' + esc(b.name) + '</h3>' +
      '<span class="fb-card__dist" data-fb-dist hidden></span></div>' +
      '<p class="fb-card__loc">' + loc + '</p><div class="fb-tags">' +
      (b.tags || []).map(function (t) { return '<span class="fb-tag">' + esc(t) + '</span>'; }).join('') +
      '</div><p class="fb-card__blurb">' + esc(b.blurb) + '</p>' +
      '<span class="fb-card__more">View details <span style="font-size:15px">\u2192</span></span></div></a>';
  }

  var done = false;
  function start() { if (done) return; done = true; initFindABaker(); }
  /* Never let a slow or missing asset leave the page inert. */
  var guard = setTimeout(start, 6000);

  fetch(url, { credentials: 'omit' })
    .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
    .then(function (full) {
      if (!Array.isArray(full) || !full.length) return;
      var have = {};
      Array.prototype.forEach.call(listEl.querySelectorAll('[data-fb-card]'), function (c) { have[c.getAttribute('data-fb-card')] = true; });
      var html = '', added = 0;
      full.forEach(function (b) {
        if (have[b.slug]) return;
        html += cardHtml(b); added++;
        window.MM_BAKERS.push(b);
      });
      if (added) listEl.insertAdjacentHTML('beforeend', html);
    })
    .catch(function () { /* keep the 50 */ })
    .then(function () { clearTimeout(guard); start(); });
})();
